<template>
  <div @keydown.esc="close">
    <portal to="modal">
      <div @click.stop="close" class="modal" :class="{ open: isOpen }">
        <div @click.stop class="modal-inner w-full container">
          <button @click="close" class="absolute p-2 top-0 right-0 text-blue">
            <XIcon />
          </button>
          <slot></slot>
        </div>
      </div>
    </portal>

    <slot name="trigger" :open="open" :close="close"></slot>
  </div>
</template>

<script>
import { XIcon } from 'vue-feather-icons';
export default {
  components: {
    XIcon
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    open() {
      this.isOpen = true;
      this.$emit('open');
    },
    close() {
      this.isOpen = false;
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  @apply fixed bg-black pointer-events-none bg-opacity-75 inset-0 z-20 flex justify-center items-center p-4 transition-opacity duration-300 ease-out opacity-0;

  &.open {
    @apply opacity-100 pointer-events-auto;

    .modal-inner {
      transform: translateY(0);
    }
  }

  .modal-inner {
    transform: translateY(-15%);
    @apply bg-white p-8 rounded shadow-lg transition-transform duration-300 ease-out;
  }
}
</style>
